import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/imgs/logo-monitur.svg'
import _imports_1 from '@/assets/imgs/icon-arrow-down-white.svg'
import _imports_2 from '@/assets/imgs/icon-admin.svg'


const _withScopeId = n => (_pushScopeId("data-v-53a7e202"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Monitur Logo Header",
  class: "logo-monitur"
}, null, -1))
const _hoisted_2 = { class: "spaced" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "caret"
}, null, -1))
const _hoisted_4 = { class: "navbar-dropdown-menu" }
const _hoisted_5 = {
  key: 0,
  class: "spaced"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "caret"
}, null, -1))
const _hoisted_7 = { class: "navbar-dropdown-menu" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "spaced"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "caret"
}, null, -1))
const _hoisted_11 = { class: "navbar-dropdown-menu" }
const _hoisted_12 = { key: 2 }
const _hoisted_13 = {
  key: 3,
  class: "spaced"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "caret"
}, null, -1))
const _hoisted_15 = { class: "navbar-dropdown-menu" }
const _hoisted_16 = {
  key: 4,
  class: "spaced"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "caret"
}, null, -1))
const _hoisted_18 = { class: "navbar-dropdown-menu" }
const _hoisted_19 = { class: "spaced" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "caret"
}, null, -1))
const _hoisted_21 = { class: "navbar-dropdown-menu" }
const _hoisted_22 = { key: 3 }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "Admin"
}, null, -1))
const _hoisted_24 = {
  key: 4,
  class: "spaced"
}
const _hoisted_25 = { class: "user-name" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "caret"
}, null, -1))
const _hoisted_27 = { class: "navbar-dropdown-menu" }
const _hoisted_28 = { class: "spaced" }
const _hoisted_29 = { class: "section-title" }
const _hoisted_30 = { class: "section-title" }
const _hoisted_31 = {
  key: 0,
  class: "spaced"
}
const _hoisted_32 = { key: 0 }
const _hoisted_33 = {
  key: 1,
  class: "spaced"
}
const _hoisted_34 = { key: 2 }
const _hoisted_35 = { class: "section-title" }
const _hoisted_36 = {
  key: 3,
  class: "spaced"
}
const _hoisted_37 = {
  key: 4,
  class: "spaced"
}
const _hoisted_38 = { class: "spaced" }
const _hoisted_39 = {
  key: 3,
  class: "login"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "Admin"
}, null, -1))
const _hoisted_41 = {
  key: 4,
  class: "spaced"
}
const _hoisted_42 = { class: "user-name" }

import { ref, computed, watch, nextTick } from "vue";
import {
  isAdmin,
  isAdminOrInternal,
  resetSessionCurrentUser,
  getSessionCurrentUser,
  hasUserLogged,
} from "@/lib/session-current-user";
import { resetLocalStorageIntegrationsData } from "@/lib/integrations-localstorage";
import { getAllPublicationsTypes } from "@/lib/get-all-publications-types";
import { onMounted } from "vue";
import ButtonComponent from "./ButtonComponent.vue";
import { translate } from "@/lib/i18n-helpers";
import { isMoniturCurrentLanguagePT } from "@/i18n";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: '_Header',
  setup(__props) {

const publicationsTypes = ref([]);

const router = useRouter();

const isShowingBackoffice = ref(location.pathname.includes("/admin"));
watch(isShowingBackoffice, () => {
  if (isShowingBackoffice.value) {
    router.push("/admin");
  } else {
    router.push("/");
  }
  resizeMenu();
});

const getUsername = computed(() => {
  return getUser().name.slice(0, 8) + "...";
});

const switchLanguage = ($i18n) => {
  let locale = $i18n.locale;
  $i18n.locale = $i18n.fallbackLocale;
  $i18n.fallbackLocale = locale;
  sessionStorage.setItem("locale", $i18n.locale);
  /*
   * Hotfix: some values that are part of the component instances
   * only change language when *refreshing the page.
   */
  location.reload();
};

function logout() {
  resetSessionCurrentUser();
  sessionStorage.removeItem("token.access");
  sessionStorage.removeItem("token.refresh");
  resetLocalStorageIntegrationsData();
  window.location.pathname = "/";
}

function getUser() {
  const user = getSessionCurrentUser();
  nextTick(() => {
    return user;
  });
  return user || { name: "user" };
}

const loading = ref(null);
const logoElement = ref(null);
const menuElement = ref(null);
const menuButton = ref(null);
const isMenuButtonClicked = ref(false);

function checkIfLinkWasClicked(event: MouseEvent) {
  const target = event.target as HTMLElement;

  if (!("tagName" in target)) return;
  if ((target.tagName as string).toLocaleLowerCase() === "a") {
    isMenuButtonClicked.value = false;
  }
}
function shouldResizeMenu(element1: HTMLElement, element2: HTMLElement) {
  const rect1 = element1.getBoundingClientRect();
  const rect2 = element2.getBoundingClientRect();

  const left1 = rect1.left + rect1.width;
  const left2 = rect2.left;

  const minDistance = 50 + (rect1.width + rect2.width) * 0.1;

  return left1 + minDistance > left2;
}

function resizeMenu() {
  if (!logoElement.value) return;

  window.requestAnimationFrame(() => {
    if (!logoElement.value || !menuElement.value) return;

    const shouldResize = shouldResizeMenu(logoElement.value, menuElement.value);

    if (shouldResize) {
      menuElement.value.style.visibility = "hidden";
      menuButton.value.style.display = "inline-block";
    } else {
      menuElement.value.style.visibility = "";
      menuButton.value.style.display = "none";
      isMenuButtonClicked.value = false;
    }
  });
}

onMounted(() => {
  loading.value.show();

  getAllPublicationsTypes().then((r) => {
    publicationsTypes.value = r.data.response.map((i) => {
      return {
        name: isMoniturCurrentLanguagePT() ? i.label_pt : i.label_en,
        category: i.value,
      };
    });

    loading.value.close();
  });
  setTimeout(resizeMenu, 200);
});

window.addEventListener("resize", resizeMenu);

return (_ctx: any,_cache: any) => {
  const _component_ModalComponent = _resolveComponent("ModalComponent")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ModalComponent, {
      ref_key: "loading",
      ref: loading
    }, null, 512),
    _createElementVNode("header", null, [
      _createElementVNode("nav", null, [
        _createElementVNode("div", {
          ref_key: "logoElement",
          ref: logoElement
        }, [
          _createVNode(_component_router_link, {
            to: isShowingBackoffice.value ? '/admin/' : '/'
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }, 8, ["to"])
        ], 512),
        _createElementVNode("div", {
          ref_key: "menuButton",
          ref: menuButton,
          class: "menu-button"
        }, [
          _createVNode(ButtonComponent, {
            "style-type": "icon",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (isMenuButtonClicked.value = !isMenuButtonClicked.value))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { icon: "mdi-menu" })
            ]),
            _: 1
          })
        ], 512),
        _createElementVNode("ul", {
          ref_key: "menuElement",
          ref: menuElement,
          class: "navbar-dropdown"
        }, [
          (!_unref(hasUserLogged)() || !isShowingBackoffice.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("li", _hoisted_2, [
                  _createElementVNode("span", null, _toDisplayString(_unref(translate)("header.publications.label")), 1),
                  _hoisted_3,
                  _createElementVNode("ul", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(publicationsTypes.value, (o, index) => {
                      return (_openBlock(), _createElementBlock("li", { key: index }, [
                        _createVNode(_component_router_link, {
                          to: `/publications/${o.category}`
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(o.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, { to: "/questionnaires" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(translate)("header.questionnaires")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, { to: "/about" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(translate)("header.about")), 1)
                    ]),
                    _: 1
                  })
                ])
              ], 64))
            : _createCommentVNode("", true),
          (_unref(hasUserLogged)() && isShowingBackoffice.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_unref(isAdminOrInternal)())
                  ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
                      _createElementVNode("span", null, _toDisplayString(_unref(translate)("header.admin.management.label")), 1),
                      _hoisted_6,
                      _createElementVNode("ul", _hoisted_7, [
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, { to: "/admin/" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(translate)("header.admin.management.indicators")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        (_unref(isAdmin)())
                          ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                              _createVNode(_component_router_link, { to: "/admin/management/users" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(translate)("header.admin.management.users")), 1)
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, { to: "/admin/management/questionnaires" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(translate)("header.admin.management.questionnaires")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, { to: "/admin/management/publications" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(translate)("header.admin.management.publications")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, { to: "/admin/management/dashboards" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(translate)("header.admin.management.dashboards")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, { to: "/admin/management/notifications" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(translate)("header.admin.management.notifications")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, { to: "/admin/management/entities" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(translate)("header.admin.management.entities")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, { to: "/admin/management/groups" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(translate)("header.admin.management.groups")), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_unref(isAdmin)())
                  ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                      _createElementVNode("span", null, _toDisplayString(_unref(translate)("header.admin.apis.label")), 1),
                      _hoisted_10,
                      _createElementVNode("ul", _hoisted_11, [
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, { to: "/admin/apis/integrations" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(translate)("header.admin.apis.integration")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, { to: "/admin/apis/configuration" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(translate)("header.admin.apis.configuration")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, { to: "/admin/apis/reports" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(translate)("header.admin.apis.reports")), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_unref(isAdmin)())
                  ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                      _createVNode(_component_router_link, { to: "/admin/audits" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(translate)("header.admin.audits")), 1)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_unref(isAdminOrInternal)())
                  ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                      _createElementVNode("span", null, _toDisplayString(_unref(translate)("header.admin.configurations.label")), 1),
                      _hoisted_14,
                      _createElementVNode("ul", _hoisted_15, [
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, { to: "/admin/configurations/lov" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(translate)("header.admin.configurations.lov.label")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, { to: "/admin/configurations/countries" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(translate)("header.admin.configurations.countries.label")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, { to: "/admin/configurations/councils" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(translate)("header.admin.configurations.councils.label")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, { to: "/admin/configurations/parishes" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(translate)("header.admin.configurations.parishes.label")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, { to: "/admin/configurations/indicators-cards" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(translate)("indicators_cards.title")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, { to: "/admin/configurations/editable-texts" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(translate)("editable_texts.title")), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_unref(hasUserLogged)())
                  ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
                      _createElementVNode("span", null, _toDisplayString(_unref(translate)("header.admin.reserved_area.title")), 1),
                      _hoisted_17,
                      _createElementVNode("ul", _hoisted_18, [
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, { to: "/admin/reserved-area/questionnaires" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(translate)("header.admin.reserved_area.questionnaires")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, { to: "/admin/reserved-area/dashboards" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(translate)("header.admin.reserved_area.dashboards")), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (_unref(hasUserLogged)())
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                (isShowingBackoffice.value)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 0,
                      class: "spaced",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (isShowingBackoffice.value = false))
                    }, _toDisplayString(_unref(translate)("public_area")), 1))
                  : _createCommentVNode("", true),
                (!isShowingBackoffice.value)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 1,
                      class: "spaced",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (isShowingBackoffice.value = true))
                    }, _toDisplayString(_unref(translate)("administrative_area")), 1))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          _createElementVNode("li", _hoisted_19, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$i18n.locale), 1),
            _hoisted_20,
            _createElementVNode("ul", _hoisted_21, [
              _createElementVNode("li", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (switchLanguage(_ctx.$i18n)))
              }, _toDisplayString(_ctx.$i18n.fallbackLocale), 1)
            ])
          ]),
          (!_unref(hasUserLogged)())
            ? (_openBlock(), _createElementBlock("li", _hoisted_22, [
                _createVNode(_component_router_link, { to: { name: 'login' } }, {
                  default: _withCtx(() => [
                    _hoisted_23
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_unref(hasUserLogged)())
            ? (_openBlock(), _createElementBlock("li", _hoisted_24, [
                _createElementVNode("span", _hoisted_25, _toDisplayString(getUsername.value), 1),
                _hoisted_26,
                _createElementVNode("ul", _hoisted_27, [
                  _createElementVNode("li", {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (logout()))
                  }, _toDisplayString(_unref(translate)("header.admin.logout")), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ], 512),
        (isMenuButtonClicked.value)
          ? (_openBlock(), _createElementBlock("ul", {
              key: 0,
              class: "responsive-menu",
              onClick: checkIfLinkWasClicked
            }, [
              (_unref(hasUserLogged)())
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (isShowingBackoffice.value)
                      ? (_openBlock(), _createElementBlock("li", {
                          key: 0,
                          class: "spaced",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (isShowingBackoffice.value = false))
                        }, _toDisplayString(_unref(translate)("public_area")), 1))
                      : _createCommentVNode("", true),
                    (!isShowingBackoffice.value)
                      ? (_openBlock(), _createElementBlock("li", {
                          key: 1,
                          class: "spaced",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (isShowingBackoffice.value = true))
                        }, _toDisplayString(_unref(translate)("administrative_area")), 1))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true),
              (!_unref(hasUserLogged)() || !isShowingBackoffice.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("li", _hoisted_28, [
                      _createElementVNode("span", null, _toDisplayString(_unref(translate)("header.publications.label")), 1),
                      _createElementVNode("ul", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(publicationsTypes.value, (o, index) => {
                          return (_openBlock(), _createElementBlock("li", { key: index }, [
                            _createVNode(_component_router_link, {
                              to: `/publications/${o.category}`
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(o.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, { to: "/questionnaires" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_29, _toDisplayString(_unref(translate)("header.questionnaires")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, { to: "/about" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_30, _toDisplayString(_unref(translate)("header.about")), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (_unref(hasUserLogged)() && isShowingBackoffice.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    (_unref(isAdminOrInternal)())
                      ? (_openBlock(), _createElementBlock("li", _hoisted_31, [
                          _createElementVNode("span", null, _toDisplayString(_unref(translate)("header.admin.management.label")), 1),
                          _createElementVNode("ul", null, [
                            _createElementVNode("li", null, [
                              _createVNode(_component_router_link, { to: "/admin/" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(translate)("header.admin.management.indicators")), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            (_unref(isAdmin)())
                              ? (_openBlock(), _createElementBlock("li", _hoisted_32, [
                                  _createVNode(_component_router_link, { to: "/admin/management/users" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref(translate)("header.admin.management.users")), 1)
                                    ]),
                                    _: 1
                                  })
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("li", null, [
                              _createVNode(_component_router_link, { to: "/admin/management/questionnaires" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(translate)("header.admin.management.questionnaires")), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("li", null, [
                              _createVNode(_component_router_link, { to: "/admin/management/publications" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(translate)("header.admin.management.publications")), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("li", null, [
                              _createVNode(_component_router_link, { to: "/admin/management/dashboards" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(translate)("header.admin.management.dashboards")), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("li", null, [
                              _createVNode(_component_router_link, { to: "/admin/management/notifications" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(translate)("header.admin.management.notifications")), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("li", null, [
                              _createVNode(_component_router_link, { to: "/admin/management/entities" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(translate)("header.admin.management.entities")), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("li", null, [
                              _createVNode(_component_router_link, { to: "/admin/management/groups" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(translate)("header.admin.management.groups")), 1)
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(isAdmin)())
                      ? (_openBlock(), _createElementBlock("li", _hoisted_33, [
                          _createElementVNode("span", null, _toDisplayString(_unref(translate)("header.admin.apis.label")), 1),
                          _createElementVNode("ul", null, [
                            _createElementVNode("li", null, [
                              _createVNode(_component_router_link, { to: "/admin/apis/integrations" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(translate)("header.admin.apis.integration")), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("li", null, [
                              _createVNode(_component_router_link, { to: "/admin/apis/configuration" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(translate)("header.admin.apis.configuration")), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("li", null, [
                              _createVNode(_component_router_link, { to: "/admin/apis/reports" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(translate)("header.admin.apis.reports")), 1)
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(isAdmin)())
                      ? (_openBlock(), _createElementBlock("li", _hoisted_34, [
                          _createVNode(_component_router_link, { to: "/admin/audits" }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_35, _toDisplayString(_unref(translate)("header.admin.audits")), 1)
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(isAdminOrInternal)())
                      ? (_openBlock(), _createElementBlock("li", _hoisted_36, [
                          _createElementVNode("span", null, _toDisplayString(_unref(translate)("header.admin.configurations.label")), 1),
                          _createElementVNode("ul", null, [
                            _createElementVNode("li", null, [
                              _createVNode(_component_router_link, { to: "/admin/configurations/lov" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(translate)("header.admin.configurations.lov.label")), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("li", null, [
                              _createVNode(_component_router_link, { to: "/admin/configurations/countries" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(translate)("header.admin.configurations.countries.label")), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("li", null, [
                              _createVNode(_component_router_link, { to: "/admin/configurations/councils" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(translate)("header.admin.configurations.councils.label")), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("li", null, [
                              _createVNode(_component_router_link, { to: "/admin/configurations/parishes" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(translate)("header.admin.configurations.parishes.label")), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("li", null, [
                              _createVNode(_component_router_link, { to: "/admin/configurations/indicators-cards" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(translate)("indicators_cards.title")), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("li", null, [
                              _createVNode(_component_router_link, { to: "/admin/configurations/editable-texts" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(translate)("editable_texts.title")), 1)
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(hasUserLogged)())
                      ? (_openBlock(), _createElementBlock("li", _hoisted_37, [
                          _createElementVNode("span", null, _toDisplayString(_unref(translate)("header.admin.reserved_area.title")), 1),
                          _createElementVNode("ul", null, [
                            _createElementVNode("li", null, [
                              _createVNode(_component_router_link, { to: "/admin/reserved-area/questionnaires" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(translate)("header.admin.reserved_area.questionnaires")), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("li", null, [
                              _createVNode(_component_router_link, { to: "/admin/reserved-area/dashboards" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(translate)("header.admin.reserved_area.dashboards")), 1)
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true),
              _createElementVNode("li", _hoisted_38, [
                _createElementVNode("ul", null, [
                  _createElementVNode("span", null, _toDisplayString(_unref(translate)("header.language")), 1),
                  _createElementVNode("li", {
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (switchLanguage(_ctx.$i18n)))
                  }, _toDisplayString(_ctx.$i18n.fallbackLocale), 1)
                ])
              ]),
              (!_unref(hasUserLogged)())
                ? (_openBlock(), _createElementBlock("li", _hoisted_39, [
                    _createVNode(_component_router_link, { to: { name: 'login' } }, {
                      default: _withCtx(() => [
                        _hoisted_40
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (_unref(hasUserLogged)())
                ? (_openBlock(), _createElementBlock("li", _hoisted_41, [
                    _createElementVNode("span", _hoisted_42, _toDisplayString(getUsername.value), 1),
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", {
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (logout()))
                      }, _toDisplayString(_unref(translate)("header.admin.logout")), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}
}

})